import { getFormattedDecimalValue, getCurrencyValue } from "@components/Amount"

export const getInvestmentTierAmount = (tierId, { investments }) => {
  const tierInvestment = investments
    .find(({ projectTierId }) => projectTierId === tierId)

  if (!tierInvestment) {
    return
  }

  const { amount } = tierInvestment

  return amount
}

export const getInvestmentTierCurrency = (tierId, investment) => {
  const amount = getInvestmentTierAmount(tierId, investment)

  return amount
    ? getCurrencyValue(getFormattedDecimalValue(0, amount, "plus"))
    : null
}

export { getCurrencyValue }
